import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from './config/config.json';
import englishText from './text/en'; // English text-version is default and will be on every school

import ifExists from '~/utils/ifExists';
// Moment configuration
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/zh-cn';
import 'moment/locale/fr';

Vue.use(VueI18n);

const DEFAULT_LOCALE = (config.locale || 'en').trim();

// Configure moment js
const MOMENT_LOCALE_MAP = {
    en: 'en-gb',
    cn: 'zh-cn',
    fr: 'fr',
};
export const mapLocaleToMoment = locale => MOMENT_LOCALE_MAP[locale] || locale;
moment.locale(mapLocaleToMoment(DEFAULT_LOCALE));

const storedLocale = ifExists(JSON.parse(window.localStorage.getItem('vuex')), u =>
    u.localeModule ? u.localeModule.locale.locale : null
);

const i18n = new VueI18n({
    locale: storedLocale || DEFAULT_LOCALE,
    fallbackLocale: 'en',
    messages: {
        en: englishText,
    },
});

// Read all text files/configs that are in ./text and add them into i18n
const textFiles = require
    .context(
        // Root folder path
        './text',
        // Whether or not to look in subfolders
        true,
        // The regular expression used to match base filename
        /(index).(js)$/
    )
    .keys()
    .forEach(fileName => {
        // Filename is on the form './en/index.js'

        // Gets the locale-name by splitting on "/"
        const directories = fileName.split('/');
        if (directories.length <= 2) {
            return;
        }
        i18n.setLocaleMessage(
            directories[1],
            require('./text/'.concat(directories[1], '/index.js')).default
        );
    });

export default i18n;
